module.exports = __webpack_public_path__ + "static/img/login-background.5505199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background.png
// module id = C2Nb
// module chunks = 1